import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { Modal } from "reactstrap";
import ProjectAddMilestone from "./ProjectModels/ProjectAddMilestone";
import ProjectSubmitwork from "./ProjectModels/ProjectSubmitwork";
import ProjectApproveSubmission from "./ProjectModels/ProjectApproveSubmission";
import { useNavigate } from "react-router-dom";
import {
  Commas,
  getDateFormate,
} from "../../../../../../Common/AllDateTimeReleventFormate";
import PaymentInfo from "./ProjectModels/PaymentInfo";
import { approwmilestonestatus } from "../../../../../../../redux/project/action";
import { useDispatch } from "react-redux";
import GetRemainDays from "./ProjectModels/GetRemainDays";
import CustomeDurationLabel from "../../../../../../Common/CustomeLabel/CustomeDurationLabel";
import { addpresent } from "../../../../../../Common/FewCommonMethods";
import GetCompletedDays from "./ProjectModels/GetCompletedDays";

export default function MineActiveProjectMilestones({ posts }) {
  const [loading, setLoading] = useState(false);
  const [index, setIndex] = useState("");
  const [proposalmilestones, setproposalmilestones] = useState("");
  const [milestonedata, setmilestonedata] = useState("");
  const [SWModel, setSWModel] = useState(false);
  const [ASModel, setASModel] = useState(false);
  const [MilesModel, setMilesModel] = useState(false);
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  useEffect(() => {
    if (Array.isArray(posts?.proposal) && posts?.is_mine == 1) {
      setproposalmilestones(posts.proposal[0]);
    } else if (Array.isArray(posts?.my_proposal) && posts?.is_mine == 0) {
      setproposalmilestones(posts.my_proposal[0]);
    }
  }, [posts]);

  const dispatch = useDispatch();

  const payammout = (item) => {
    const state = {
      id: item?.id,
      milestone_id: item?.id,
      milestone_amount: item?.amount,
      type: 1,
      type_of_post: "project",
      post_id: posts?.id,
      post_price: posts?.price,
      move: "activepage",
    };
    navigate(`/${lan}/account/paymentmethodpage`, {
      state: { orderdetails: state },
    });
  };
  const rejectmilestone = (item) => {
    const data = {
      type: "3",
      milestone_id: item?.id,
      status: "6",
    };
    dispatch(approwmilestonestatus(data, setLoading));
  };
  const approwmilestone = (item) => {
    const data = {
      type: "3",
      milestone_id: item?.id,
      status: "1",
    };
    dispatch(approwmilestonestatus(data, setLoading));
  };

  return (
    <div className="col-md-12 project-milestone">
      <div
        isOpen={SWModel}
        keyboard={false}
        className={
          SWModel
            ? `modal viewsubmission-modal add-education-modal add-bxp-modal active`
            : "modal viewsubmission-modal add-education-modal add-bxp-modal"
        }
        id="viewsubmission"
      >
        <ProjectApproveSubmission
          index={index}
          posts={posts}
          milestonedata={milestonedata}
          setSWModel={setSWModel}
        />
      </div>
      <Modal
        isOpen={ASModel}
        keyboard={false}
        className="modal-centered popupmodal "
      // size="xl"
      >
        <ProjectSubmitwork
          index={index}
          milestonedata={milestonedata}
          setASModel={setASModel}
        />
      </Modal>
      <Modal
        isOpen={MilesModel}
        keyboard={false}
        className="modal-centered popupmodal mile-modal"

      >
        <ProjectAddMilestone
          index={index}
          proposalmilestones={proposalmilestones}
          setMilesModel={setMilesModel}
        />
      </Modal>
      <div className="row justify-content-between">
        <div className="col-md-8">
          {Array.isArray(proposalmilestones?.milestones) &&
            proposalmilestones?.milestones.map((item, index) => {
              if (item?.status == 0) {
                return (
                  <div className="design-brand" key={index}>
                    <div className="number-span">
                      <span className="number">{index + 1}</span>
                    </div>
                    <div className="number-right">
                      <h5>{item?.title}</h5>
                      <h2>$ {Commas(item?.amount)}</h2>
                      <p>
                        Deadline:&nbsp;
                        <CustomeDurationLabel
                          duration={item?.duration}
                          duration_type={item?.duration_type}
                        />
                      </p>
                      <p>
                        Penalty:&nbsp;
                        {item.penalty ? addpresent(item.penalty) : "-----"}
                      </p>
                      {item?.is_mine == 1 ? (
                        ""
                      ) : (
                        <>
                          <span className="work-submit">
                            <span
                              style={{ color: "green" }}
                              onClick={() => approwmilestone(item)}
                            >
                              Accept
                            </span>
                          </span>
                          <span className="work-submit">
                            <span
                              style={{ color: "red" }}
                              onClick={() => rejectmilestone(item)}
                            >
                              Reject
                            </span>
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                );
              }
              if (item?.status == 1) {
                return (
                  <div className="design-brand" key={index}>
                    <div className="number-span">
                      <span className="number">{index + 1}</span>
                    </div>
                    <div className="number-right">
                      <h5>{item?.title}</h5>
                      <h2>$ {Commas(item?.amount)}</h2>
                      <p>
                        Penalty:&nbsp;
                        {item.penalty ? addpresent(item.penalty) : "-----"}
                      </p>
                      {item?.pay_now == 1 ? (
                        <div className="work-submit">
                          <button
                            className="btn"
                            onClick={() => {
                              payammout(item);
                            }}
                          >
                            Pay Amount
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                );
              } else if (
                item?.status == 2 ||
                item?.status == 3 ||
                item?.status == 4
              ) {
                return (
                  <div className="design-brand" key={index}>
                    <div className="number-span progress-number">
                      <span className="number">{index + 1}</span>
                    </div>
                    <div className="number-right">
                      <h5>{item?.title}</h5>
                      <h2>
                        $ {Commas(item?.amount)}
                        <span className="progress-sec">In_progress</span>
                      </h2>

                      {posts?.is_mine == 1 ? (
                        <>
                          {item?.status >= 3 ? (
                            <div className="work-submit">
                              <button
                                className="btn"
                                onClick={() => {
                                  setSWModel(true);
                                  setmilestonedata(item);
                                  setIndex(index + 1);
                                }}
                              >
                                View Submission
                                <img
                                  src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/square-arrow.svg`}
                                  alt=""
                                />
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        <>
                          {item?.status == 3 ? (
                            <div className="work-submit" key={index}>
                              <button
                                className="btn"
                                onClick={() => {
                                  setSWModel(true);
                                  setmilestonedata(item);
                                  setIndex(index + 1);
                                }}
                              >
                                View Submission
                                <img
                                  src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/square-arrow.svg`}
                                  alt=""
                                />
                              </button>
                            </div>
                          ) : (
                            <div className="work-submit" key={index}>
                              <button
                                className="btn"
                                onClick={() => {
                                  setASModel(true);
                                  setmilestonedata(item);
                                  setIndex(index + 1);
                                }}
                              >
                                Submit work for payment
                              </button>
                            </div>
                          )}
                        </>
                      )}
                      <p className="numberright-p">
                        Due on : {getDateFormate(item.ends_on)}
                      </p>
                      <GetRemainDays enddate={item.ends_on} />
                      <p>
                        Penalty:&nbsp;
                        {item.penalty ? addpresent(item.penalty) : "-----"}
                      </p>
                    </div>
                  </div>
                );
              } else if (item?.status == 5) {
                return (
                  <div className="design-brand" key={index}>
                    <div className="number-span active-number">
                      <span className="number">{index + 1}</span>
                    </div>
                    <div className="number-right">
                      <h5>{item?.title}</h5>
                      <h2>
                        $ {Commas(item?.amount)}
                        <span className="approved-paid">Approved & Paid</span>
                      </h2>
                      <div className="work-submit">
                        <div>
                          <h6>Work submitted</h6>
                          <GetCompletedDays enddate={item.submition[0]?.created_on} />
                          <button
                            className="btn"
                            onClick={() => {
                              setSWModel(true);
                              setmilestonedata(item);
                              setIndex(index + 1);
                            }}
                          >
                            View Submission
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/square-arrow.svg`}
                              alt=""
                            />
                          </button>
                        </div>
                        <p className="approved">Approved</p>
                      </div>
                    </div>
                  </div>
                );
              }
               else if (item?.status == 6) {
                return (
                  <div className="design-brand" key={index}>
                    <div className="number-span" >
                      <span className="number">{index + 1}</span>
                    </div>
                    <div className="number-right">
                      <h5>{item?.title}</h5>
                      <h2>$ {Commas(item?.amount)}
                        <span style={{background:'red', color:'#fff', borderColor:'red'}} className="progress-sec">Rejected</span>
                      </h2>
                      <p>
                        Penalty:&nbsp;
                        {item.penalty ? addpresent(item.penalty) : "-----"}
                      </p>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          {posts?.status == 3 ? (
            <div className="design-brand add-mile">
              <div className="number-span active-number">
                <span className="number">
                  <span className="fa-solid fa-star checked"></span>
                </span>
              </div>
              <div className="number-right">
                <h3 style={{ color: "green" }}>Project Completed</h3>
              </div>
            </div>
          ) : (
            <>
              {posts?.is_bxp == 1 ?
                <div className="design-brand add-mile">
                  <div className="number-span active-number">
                    <span className="number">
                      <span className="fa-solid fa-star checked"></span>
                    </span>
                  </div>
                  <div className="number-right">
                    <h3 style={{ color: "green" }}></h3>
                  </div>
                </div>
                :
                <div
                  className="design-brand add-mile"
                  onClick={() => setMilesModel(true)}
                >
                  <div className="number-span ">
                    <span className="number">+</span>
                  </div>
                  <div className="number-right">
                    <h3>Add milestone</h3>
                  </div>
                </div>
              }

            </>
          )}
        </div>
        <PaymentInfo
          posts={posts}
          proposalmilestones={proposalmilestones}
        />
      </div>
    </div>
  );
}
